
<template>
  <!-- <img alt="Vue logo" src="../assets/logo.png"> -->
  <div>
    <div class="titlebar">
      <div class="container">
        
          <a>
            <router-link
          :to="{ path: this.$router.currentRoute.meta.backTo, query: $router.currentRoute.query}"
        >
            <i v-if="$router.currentRoute.meta.backTo" class="icon-arrow-left"></i>
             </router-link>
          </a>
          {{ $t(this.$router.currentRoute.name)}}

          <span v-if="this.$router.currentRoute.meta.showId && !this.$router.currentRoute.query['order-session']">{{$router.currentRoute.params[$router.currentRoute.meta.showId]}}</span>
          <span v-if="this.$router.currentRoute.meta.showId && this.$router.currentRoute.query['order-session']">{{$router.currentRoute.query['order-session']}}</span>
       
        <!-- <a :href="this.$router.currentRoute.meta.backTo">
          <i class="icon-arrow-left"></i>
        </a>
        {{ $t(this.$router.currentRoute.name)}} -->
      </div>
    </div>
  </div>
</template>

<script>
// Guide:
// import './'  // 同一層目錄開始找
// import '../' // 上一層目錄開始找
// import '@/'  // src目錄下開始找
// import ''    // 直接打名稱則是node_modules

// @ is an alias to /src

export default {
  name: "userDataHeader",
  components: {},
  mounted() {
    // console.info('App this router:', this.$router)
    console.info("App currentRoute:", this.$router.currentRoute.meta);
  }
};
</script>

<style scoped>
/* @import '../assets/css/theme_default.css'; */
</style>